module.exports = __webpack_public_path__ + "img/soft-ice-cream-emoji.34d8d6e4.png";